import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.2",
  viewBox: "0 0 27.975 19.826"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M3.51 16.899a2.328 2.328 0 1 0 2.328-2.328 2.328 2.328 0 0 0-2.328 2.328ZM19.808 16.899a2.328 2.328 0 1 0 2.328-2.328 2.328 2.328 0 0 0-2.328 2.328Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M3.51 16.898H1.764A1.164 1.164 0 0 1 .6 15.734v-4.639a1.164 1.164 0 0 1 .488-.949l3.587-1.4.944-4.939a1.164 1.164 0 0 1 1.129-.881h4.329V1.767A1.164 1.164 0 0 1 12.241.603h13.97a1.164 1.164 0 0 1 1.164 1.164v13.97a1.164 1.164 0 0 1-1.164 1.164h-1.746M8.166 16.898h11.642M11.077 2.929V14.57M.6 13.406h1.746M4.674 8.75h6.4" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }